// Mapa de nombres de icono (del backend) -> componentes lucide-react.
import {
  LayoutDashboard, Plane, Calculator, Boxes, Headphones, CalendarCheck,
  ShieldAlert, ListTodo, KanbanSquare, Users, Building2, Receipt, Wallet,
  BookText, BarChart3, PieChart, UserCog, GraduationCap, Users2, ShieldCheck,
  ScrollText, Sigma, Circle, Mailbox, MessageSquare, MessagesSquare, DatabaseBackup, CreditCard, TrendingUp, FileText, Megaphone, Trophy,
  BookOpen, CalendarDays, IdCard, Coins, CalendarRange, Clock, ClipboardList, Landmark, LayoutTemplate, Package, PauseCircle,
} from "lucide-react";

const ICONS = {
  LayoutDashboard, Plane, Calculator, Boxes, Headphones, CalendarCheck,
  ShieldAlert, ListTodo, KanbanSquare, Users, Building2, Receipt, Wallet,
  BookText, BarChart3, PieChart, UserCog, GraduationCap, Users2, ShieldCheck,
  ScrollText, Sigma, Mailbox, MessageSquare, MessagesSquare, DatabaseBackup, CreditCard, TrendingUp, FileText, Megaphone, Trophy,
  BookOpen, CalendarDays, IdCard, Coins, CalendarRange, Clock, ClipboardList, Landmark, LayoutTemplate, Package, PauseCircle,
};

export const getIcon = (name) => ICONS[name] || Circle;
